import { ApiError, NetworkError } from "./client";

// Tradução de `code` da API para mensagem que faz sentido pro associado — nunca expõe stack trace,
// nome de tabela ou detalhe técnico (blueprint, seção 8: "erros... sem vazar detalhe interno").
const MESSAGES: Record<string, string> = {
  invalid_credentials: "Usuário ou senha incorretos.",
  temporary_password_expired:
    "Sua senha temporária expirou. Procure o suporte técnico para receber uma nova.",
  missing_fields: "Preencha todos os campos obrigatórios.",
  weak_password: "A nova senha precisa ter pelo menos 8 caracteres.",
  unauthorized: "Sua sessão expirou. Faça login novamente.",
  mfa_elevation_required: "Confirme o autenticador para continuar.",
  member_not_found: "Não encontramos um cadastro de associado vinculado a esta sessão.",
  operation_failed_previously: "Esta operação falhou antes. Tente novamente.",
  auth_update_failed: "Não foi possível concluir a troca de senha agora. Tente novamente.",
  invalid_body: "Não foi possível entender os dados enviados.",
  method_not_allowed: "Operação não permitida.",
  internal_error: "Algo deu errado do nosso lado. Tente novamente em instantes.",
  unknown_error: "Erro inesperado. Tente novamente em instantes.",
};

export function friendlyErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    return MESSAGES[error.code] ?? error.message ?? MESSAGES.unknown_error;
  }
  if (error instanceof NetworkError) {
    return "Não foi possível conectar ao servidor. Verifique sua internet e tente novamente.";
  }
  if (error instanceof Error) {
    return error.message;
  }
  return MESSAGES.unknown_error;
}
